import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MsalModule } from '@azure/msal-angular';
import { LoadSpManifestService } from '../../sp_globals/services/load-sp-manifest.service';
import { silSp } from './sil-sp.manifest';
import { SpGlobalModule } from '../../sp_globals/sp-global.module';
import { IdentityModule } from '@flexus/identity';
import { PublicClientApplication } from '@azure/msal-browser';
import { SpUserModule } from '../../sp-user/sp-user.module';


export function loadConfig(manifest: LoadSpManifestService) {
	return function () {
		return manifest.load(silSp);
	};
}
@NgModule({
	imports: [
		CommonModule,
		...environment.appShellFeatures,
		SpGlobalModule,
    SpUserModule,
		environment['azure']
			? MsalModule.forRoot(
					new PublicClientApplication({
						auth: {
							clientId: environment['azure']['clientId'],
							postLogoutRedirectUri: `${environment.base_url}auth/login`
						}
					}),
					null,
					null
			  )
			: CommonModule,
		IdentityModule.forRoot({
			after_login_url: '/workflow',
			after_logout_url: '/auth/login',
			send_reset_link_endpoint: `${environment.api_url}v1/forgot_password/check-email`,
			login_endpoint: `${environment.api_url}v2/auth/login/`,
			no_auth_urls: ['/cons']
		})
	],
	declarations: [],
	exports: [...environment.appShellFeatures],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: loadConfig,
			deps: [LoadSpManifestService],
			multi: true
		}
	]
})
export class SilSpManifestModule {}
